import type { PrinterPages } from '@justomx/atlas-components'
import { useNavigate } from 'react-router-dom'
import { useQueryParam, useRequiredParams } from 'hooks/params.hook'
import { isLocal } from 'utils/environment'
import { useGoToPreparation } from '../preparation/Preparation.navigator'

export const useScanPrinter = () => {
  const navigate = useNavigate()
  const redirectOnSuccess = useQueryParam('redirectOnSuccess')
  const preparationPage = useGoToPreparation()
  const { transferId, docNum } = useRequiredParams('transferId', 'docNum')

  const onPrinterPageChange = (page: PrinterPages) => {
    if (page === 'DETAIL_PAGE' && !!redirectOnSuccess) {
      preparationPage.go(transferId, docNum)
    }

    // for local debugging only
    if (isLocal()) {
      setTimeout(() => {
        if (page === 'LOADING') {
          if (redirectOnSuccess) {
            preparationPage.go(transferId, docNum)
          } else {
            navigate(-1)
          }
        }
      }, 7000)
    }
  }

  const onGoBack = () => {
    if (!!redirectOnSuccess) {
      preparationPage.go(transferId, docNum)
      return
    }
    navigate(-1)
  }

  return {
    actions: {
      onGoBack,
      onPrinterPageChange
    }
  }
}
